import type { ReactNode } from 'react';

interface KanbanColumnProps {
  label: string;
  count: number;
  accent?: 'blue' | 'orange' | 'amber' | 'emerald' | 'red';
  children: ReactNode;
}

const ACCENT_BARS = {
  blue: 'bg-blue-500',
  orange: 'bg-orange-500',
  amber: 'bg-amber-500',
  emerald: 'bg-emerald-500',
  red: 'bg-red-500',
};

export function KanbanColumn({ label, count, accent = 'blue', children }: KanbanColumnProps) {
  return (
    <div className="flex flex-col rounded-xl bg-slate-50 border border-slate-200 min-w-[280px] max-w-[320px]">
      <div className="flex items-center justify-between p-3 border-b border-slate-200">
        <div className="flex items-center gap-2">
          <div className={`h-2 w-2 rounded-full ${ACCENT_BARS[accent]}`} />
          <h3 className="font-semibold text-slate-900 text-sm uppercase tracking-wide">{label}</h3>
        </div>
        <span className="text-xs font-medium text-slate-600 bg-white border border-slate-200 rounded-full px-2 py-0.5">
          {count}
        </span>
      </div>
      <div className="flex-1 overflow-y-auto p-2 space-y-2 max-h-[calc(100vh-280px)]">
        {children}
      </div>
    </div>
  );
}
